import store from '@/store'
import { dateToDbUtcString, mapTimeEntries } from '@/utils/timeEntry'
import moment from 'moment'

const state = {
  timeEntrySortProp: 'date',
  timeEntrySortAscending: false
}

const mutations = {
  setTimeEntrySortProp (state, prop) {
    state.timeEntrySortProp = prop
  },
  setTimeEntrySortAscending (state, ascending) {
    state.timeEntrySortAscending = ascending
  },
  toggleTimeEntrySortAscending (state) {
    state.timeEntrySortAscending = state.timeEntrySortAscending !== true
  }
}

const getters = {
  timeEntrySortProp: state => state.timeEntrySortProp,
  timeEntrySortAscending: state => state.timeEntrySortAscending,

  timeEntries: () => {
    let range = store.getters.currentDateRange
    let rangeStart = moment(dateToDbUtcString(range[0]))
    let rangeEnd = moment(dateToDbUtcString(range[1]))
    let userIds = store.getters.adminMode ? store.getters.selectedUsers.map(user => user.id) : [store.state.authentication.user.id]
    let entries = store.getters['time-entries/all']
    let timeEntries = entries.filter(entry => {
      return userIds.includes(entry.relationships.user.data.id) && moment(entry.attributes.start) >= rangeStart && moment(entry.attributes.start) <= rangeEnd
    })
    let mappedTimeEntries = mapTimeEntries(timeEntries)

    return mappedTimeEntries
  },

  timeEntryFilters: () => {
    let range = store.getters.currentDateRange
    let userIds = store.getters.adminMode ? store.getters.selectedUsers.map(user => user.id) : [store.state.authentication.user.id]

    return {
      options: {
        'filter[user][in]': userIds.join(','),
        'filter[start][ge]': dateToDbUtcString(range[0]),
        'filter[start][le]': dateToDbUtcString(range[1])
      }
    }
  }
}

export default {
  state,
  mutations,
  getters
}
